import { useEffect, useState, useContext } from 'react';
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { DataContext } from 'providers/data';

import Fade from '@mui/material/Fade';
import Input from 'components/views/form/Input';
import { Typography, Box, Button } from '@mui/material';
import FadeAnimation from 'components/views/FadeAnimation';
import { ButtonRectangle } from 'components/views/form/Button';
import ModalAlertSecurity from 'components/views/ModalAlertSecurity';

import { Container, ContentBackground, ContentLogin, Form, LinkCharges } from './styles';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { ReactComponent as IcIturan } from 'assets/icons/ic-ituran.svg';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { ReactComponent as IcBallsBackground } from 'assets/icons/ic-balls-background.svg';

const Login = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { errorLogin, handlePostAuthentication, handleClearLogout, handleGetActiveLoginBanner } = useContext(DataContext);
    const [isDesktop, setIsDesktop] = useState(false);
    const [isShowForm, setIsShowForm] = useState(false);
    const [isShowError, setIsShowError] = useState(false);
    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const [isBtnDisabled, setIsBtnDisabled] = useState(true);
    const { register, handleSubmit, watch, setValue } = useForm();

    const login = watch('login');
    const password = watch('password');

    const handleClearData = () => {
        localStorage.clear();
        handleClearLogout();
    }

    const onSubmit = () => {
        setIsBtnLoading(true);
        handlePostAuthentication({ usuario: login, password: password });
    }

    useEffect(() => {
        handleClearData();
        handleGetActiveLoginBanner();

        if (window && window.innerWidth > 992) {
            setIsDesktop(true);
        } else {
            setIsDesktop(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (state) {
            setValue('login', state?.login);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    useEffect(() => {
        if (login && password) {
            setIsBtnDisabled(false);
        } else {
            setIsBtnDisabled(true);
        }

        if (errorLogin.isError) {
            setIsBtnLoading(false);
            if (errorLogin.login === login && errorLogin.password === password) {
                setIsShowError(true);
                setIsBtnDisabled(true);
            } else {
                setIsShowError(false);
            }
        } else {
            setIsShowError(false);
        }
    }, [errorLogin, login, password]);

    return (
        <FadeAnimation>
            <Container>
                {(!isShowForm || isDesktop) &&
                    <Fade in={(!isShowForm || isDesktop)} {...((!isShowForm || isDesktop) ? { timeout: 500 } : {})}>
                        <ContentBackground>
                            <IcIturan />

                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                flexDirection: 'column',
                                justifyContent: 'center',
                            }}>
                                <Box maxWidth='20rem' sx={{
                                    alignItems: 'center',
                                    marginBottom: {
                                        xs: '0',
                                        md: '7.185rem'
                                    },
                                    flexDirection: 'column'
                                }}>
                                    <Typography color='white' fontWeight={800} textAlign='center' sx={{
                                        fontSize: {
                                            md: '2rem',
                                            xs: '1.25rem'
                                        },
                                        paddingBottom: {
                                            md: '1rem',
                                            xs: '.625rem'
                                        }
                                    }}>
                                        ÁREA DO CLIENTE
                                    </Typography>

                                    <Typography variant='subtitle2' color='white' textAlign='center' sx={{
                                        fontWeight: {
                                            md: 500,
                                            xs: 600
                                        },
                                        lineHeight: {
                                            md: '22px',
                                            xs: '15px'
                                        }
                                    }}>
                                        Este é um espaço dedicado ao cliente Ituran. <br />
                                        Aqui você encontra Comodidade e Praticidade para acessar os serviços que você precisa!
                                    </Typography>
                                </Box>

                                <Box sx={{
                                    display: {
                                        md: 'flex',
                                        sm: 'none',
                                        xs: 'none'
                                    },
                                    flexDirection: 'column',
                                    textAlign: 'center',
                                    'a': {
                                        color: 'white',
                                    }
                                }}>
                                    <Typography fontSize='.875rem' color='white' paddingBottom='.5rem' lineHeight='1.3'>
                                        <a href="https://iweb.ituran.com.br/iweb2/?_ga=2.68055321.929441447.1686592226-1107789947.1686592224" target='blank'>
                                            <b><u>ITURAN WEB</u></b>
                                        </a>
                                    </Typography>
                                </Box>
                            </Box>
                        </ContentBackground>
                    </Fade>
                }
                <ContentLogin>
                    {(isShowForm || isDesktop) &&
                        <Fade in={(isShowForm || isDesktop)} {...((isShowForm || isDesktop) ? { timeout: 500 } : {})}>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <Box sx={{
                                    width: '100%',
                                    display: {
                                        md: 'none',
                                        xs: 'flex'
                                    },
                                    paddingBottom: '2rem'
                                }} alignItems='center' justifyContent='flex-start' onClick={() => setIsShowForm(false)}>
                                    <ArrowBackIosNewIcon fontSize='small' />
                                    <Typography fontSize='1.125rem' fontWeight={400} paddingTop='3px' paddingLeft='.6rem'>
                                        Início
                                    </Typography>
                                </Box>

                                <Fade in={isShowError} {...((isShowError) ? { timeout: 500 } : {})}>
                                    <Box sx={{
                                        padding: {
                                            xs: '.5rem .81rem',
                                            md: '.75rem .93rem'
                                        },
                                        top: 0,
                                        marginTop: {
                                            xs: '58px',
                                            md: '-56px'
                                        },
                                        position: 'absolute',
                                        backgroundColor: '#FF0000',
                                    }}>
                                        <Typography fontWeight={600} color="white" sx={{
                                            fontSize: {
                                                md: '.9375rem',
                                                xs: '.875rem'
                                            }
                                        }}>
                                            O login ou a senha informados não correspodem a um usuário Ituran.
                                            <br />
                                            <b style={{ paddingTop: '.5rem', display: 'flex' }}>Por favor, tente novamente.</b>
                                        </Typography>
                                    </Box>
                                </Fade>

                                <Typography fontWeight={700} sx={{
                                    fontSize: {
                                        md: '1.56rem',
                                        xs: '1.25rem'
                                    },
                                    paddingBottom: {
                                        xs: '1.5625rem',
                                        md: '.875rem'
                                    }
                                }}>
                                    Bem-vindo, faça seu login
                                </Typography>

                                <Input name='login' label='Login' placeholder='Seu login' type='text' register={{ ...register("login", { required: true }) }} />
                                <Input name='password' label='Senha' placeholder='Sua senha' type='password' register={{ ...register("password", { required: true }) }} />

                                <ButtonRectangle name='ACESSAR' disabled={isBtnDisabled} loadingBtn={isBtnLoading} type="submit" />

                                <Box sx={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    padding: {
                                        lg: '1.125rem 0 1.4375rem',
                                        md: '1.125rem 0 .875rem',
                                        xs: '1.5rem 0 2rem'
                                    },
                                    borderBottom: '1px solid #8D9BB5'
                                }}>
                                    <Link to='esqueci-senha'>
                                        <Typography variant='subtitle2'>
                                            Esqueci minha senha
                                        </Typography>
                                    </Link>

                                    <Link to='esqueci-login'>
                                        <Typography variant='subtitle2'>
                                            Esqueci meu login
                                        </Typography>
                                    </Link>
                                </Box>

                                <Box width='100%' textAlign='center'>
                                    <Typography variant='h6' fontWeight={500} sx={{
                                        marginTop: {
                                            md: '1.3rem',
                                            xs: '2rem'
                                        }
                                    }}>
                                        Ainda não é cadastrado?
                                    </Typography>

                                    <Button variant="outlined" type='button' sx={{
                                        width: '100%',
                                        height: {
                                            xs: '2.8175rem',
                                            md: '2.3rem',
                                            lg: '2.8175rem'
                                        },
                                        borderRadius: '5px',
                                        border: '1.5px solid #0C1C33',
                                        fontSize: '1rem',
                                        fontWeight: 700
                                    }}
                                        onClick={() => navigate('primeiro-acesso')}
                                    >
                                        MEU 1º ACESSO
                                    </Button>
                                </Box>
                            </Form>
                        </Fade>
                    }

                    {(!isShowForm || isDesktop) &&
                        <Fade in={(!isShowForm || isDesktop)} {...((!isShowForm || isDesktop) ? { timeout: 500 } : {})}>
                            <Box sx={{
                                width: '100%',
                                gap: {
                                    xs: '1.93rem',
                                    md: '1rem',
                                    lg: '1.93rem'
                                },
                                display: 'flex',
                                alignItems: 'center',
                                flexDirection: 'column',
                                justifyContent: 'center'
                            }}>
                                <Box sx={{
                                    width: '100%',
                                    display: {
                                        md: 'none',
                                        xs: 'grid'
                                    },
                                    textAlign: 'center',
                                    paddingTop: '2.18rem'
                                }}>
                                    <Typography variant='subtitle2' paddingBottom='1.125rem'>
                                        Escolha a <b>opção</b> desejada:
                                    </Typography>
                                    <ButtonRectangle name='Faça seu login' type="button" onClick={() => setIsShowForm(true)} />
                                </Box>

                                <Box sx={{
                                    width: {
                                        md: '24rem',
                                        xs: '100%'
                                    }
                                }}>
                                    <LinkCharges to='/cobrancas'>
                                        <DescriptionOutlinedIcon />
                                        2ª via de boleto
                                    </LinkCharges>
                                </Box>


                                <Box sx={{
                                    width: '100%',
                                    display: 'flex',
                                    maxWidth: '18.5rem',
                                    paddingBottom: '.0rem',
                                    justifyContent: 'space-between',
                                    'a': {
                                        fontSize: '.75rem',
                                        color: 'primary.main',
                                        textDecoration: 'underline'
                                    }
                                }}>
                                    <a href="https://www.ituran.com.br/politica-de-privacidade/" target='blank'>
                                        Política de Privacidade
                                    </a>
                                    <a href="https://www.ituran.com.br/termos-de-uso/" target='blank'>
                                        Termos de Uso
                                    </a>
                                </Box>

                                <Box sx={{
                                    display: {
                                        xs: 'flex',
                                        md: 'none'
                                    },
                                    flexDirection: 'column',
                                    textAlign: 'center',
                                    'a': {
                                        color: 'primary.main',
                                    }
                                }}>
                                    <Typography fontSize='.75rem' paddingBottom='.5rem' lineHeight='1.3'>
                                        <a href="https://iweb.ituran.com.br/iweb2/?_ga=2.68055321.929441447.1686592226-1107789947.1686592224" target='blank'>
                                            <b><u>ITURAN WEB</u></b>
                                        </a>
                                    </Typography>
                                </Box>
                            </Box>
                        </Fade>
                    }
                    <Typography fontSize='.75rem' sx={{
                        position: 'absolute',
                        bottom: {
                            xs: '1.875rem',
                            md: '.5rem',
                            lg: '1.875rem'
                        }
                    }}>
                        © Copyright 2023. Ituran. Todos os direitos reservados
                    </Typography>

                    <IcBallsBackground id='ic-background' />
                </ContentLogin>
                <ModalAlertSecurity />
            </Container>
        </FadeAnimation >
    );
}

export default Login;